// src/pages/instances/InstancesPage.tsx
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { message } from "antd";
import PageHeader from "../../../components/Common/PageHeader";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import { FilterField } from "../../../components/Common/TableFilter/TableFilter";

import useInstances from "../hooks/useInstances";
import AddEditInstanceModal from "../modals/AddEditInstanceModal";
import InstancesTable from "../tables/InstancesTable";
import { Instance, InstanceCreatePayload, InstanceUpdatePayload } from "types/superAdmin/instanceTypes";
import ShowDirectorsModal from "../modals/ShowDirectorsModal";
import { CreateInstancePayloadForApi, UpdateInstancePayloadForApi } from "services/superAdmin/instenceService";
import useUsers from "../hooks/useUsers";
import AddDirectorModal from "../modals/AddDirectorModal";
import { UserCreatePayload } from "types/superAdmin/userTypes";
import { all_routes } from "router/all_routes";
// import { updateInstance } from "../../../services/instanceService";

const InstancesPage = () => {
  const { t } = useTranslation();

  const {
    instances,
    loading,
    selectedInstance,
    setSelectedInstance,
    isModalOpen,
    setIsModalOpen,
    fetchInstances,
    handleCreate,
    handleUpdate,
    infoPagination,
    handleDelete,
  } = useInstances();

  const { handleDelete: handleDeleteUser , handleCreate: handleCreateUser } = useUsers();



  const breadcrumbItems = [
    { label: "dashboard", path: all_routes.superAdmin.dashboard },
    { label: "instances", active: true },
  ];

  const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});
  const [directorsOpen, setDirectorsOpen] = useState(false);
  const [directorsInstance, setDirectorsInstance] = useState<Instance | null>(null);
  const [createDirectorOpen, setCreateDirectorOpen] = useState(false);

  useEffect(() => {
    fetchInstances();
    console.log(infoPagination);
    console.log(instances);
  }, [fetchInstances]);

  const filterFields: FilterField[] = [
    { key: "search", label: t("search"), type: "text" },
    {
      key: "status",
      label: t("status"),
      type: "select",
      options: [
        { label: t("all"), value: "" },
        { label: t("active"), value: "active" },
        { label: t("deleted"), value: "deleted" },
      ],
    },
  ];

  const handleSaveInstance = async (
    payload: CreateInstancePayloadForApi | UpdateInstancePayloadForApi
  ) => {
    // UPDATE
    if (selectedInstance?.id) {
      const ok = await handleUpdate(selectedInstance.id, payload as UpdateInstancePayloadForApi);
      if (ok) {
        setIsModalOpen(false);
        fetchInstances(filters as any);
      }
      return !!ok;
    }
  
    // CREATE
    const ok = await handleCreate(payload as CreateInstancePayloadForApi);
    if (ok) {
      setIsModalOpen(false);
      fetchInstances(filters as any);
    }
    return !!ok;
  };
  

  const handleFilter = (newFilters: { [key: string]: string | number | null }) => {
    setFilters(newFilters);
    const cleanFilters = Object.fromEntries(
      Object.entries(newFilters).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    );
    fetchInstances(cleanFilters as any);
  };

  const onEdit = (record: Instance) => {
    setSelectedInstance(record);
    setIsModalOpen(true);
  };

  const onShowDirectors = (record: Instance) => {
    setDirectorsInstance(record);
    setDirectorsOpen(true);
  };

  const onAddDirector = (record: Instance) => {
    setDirectorsInstance(record);
    setCreateDirectorOpen(true);
  };

  const onDelete = (record: Instance) => {
    handleDelete(record.id);
    fetchInstances(filters as any);
  };

  const handleCreateDirector = async (payload: UserCreatePayload) => {
    const ok = await handleCreateUser(payload);
    if (ok) {
      setCreateDirectorOpen(false);
      fetchInstances(filters as any);
    }
    return !!ok;
  };

  const handleDeleteDirector = (record: Instance) => {
    handleDeleteUser(record.id);
    setDirectorsOpen(false);
    fetchInstances(filters as any);
  };
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader title={t("instances")} breadcrumbItems={breadcrumbItems} />

        <div className="d-flex mb-3 justify-content-end gap-2">
          <button
            className="btn btn-primary"
            onClick={() => {
              setSelectedInstance(null);
              setIsModalOpen(true);
            }}
          >
            <i className="ti ti-plus me-2" />
            {t("add_instance")}
          </button>

          <TableFilterDynamique
            fields={filterFields}
            filters={filters}
            onApply={(newFilters) => handleFilter(newFilters)}
            onReset={() => {
              setFilters({});
              fetchInstances({});
            }}
          />
        </div>

        <InstancesTable
          dataSource={instances}
          loading={loading}
          onEdit={onEdit}
          onShowDirectors={onShowDirectors}
          onAddDirector={onAddDirector}
          pagination={true}
          onDelete={onDelete}
          dataPaginate={{
            current: infoPagination?.page,
            pageSize: infoPagination?.limit,
            total: infoPagination?.total,
          }}
          onChange={(pg) => {
            fetchInstances({
              ...filters,
              page: pg.current!,
              limit: pg.pageSize!,
            });
          }}
        />

        {/* Create / Edit */}
        <AddEditInstanceModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          instanceData={selectedInstance}
          onSave={handleSaveInstance}
        />

        {/* Show Directors */}
        <ShowDirectorsModal
          isOpen={directorsOpen}
          onClose={() => setDirectorsOpen(false)}
          instance={directorsInstance}
          onDelete={handleDeleteDirector}
        />

        {/* Create Director */}
        <AddDirectorModal
          isOpen={createDirectorOpen}
          onClose={() => setCreateDirectorOpen(false)}
          instanceId={directorsInstance?.id || ""}
          onCreated={handleCreateDirector}
        />
      </div>
    </div>
  );
};

export default InstancesPage;
